<app-type-voie  [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled" [rule]="rule"
 [voie]="lieuExecutionLivraison?.voie"></app-type-voie>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
[value]="lieuExecutionLivraison?.cp" 
[label]="step2.getcp"
[type]="'text'" [rule]="'pattern_3'"
[errorMessage]="errorMessage"
[name]="getUid()+'_SepAtt_cp'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
[value]="lieuExecutionLivraison?.ville" 
[label]="step2.getville"
[type]="'text'" [rule]="'minSize_1|maxSize_100'"
[name]="getUid()+'_SepAtt_ville'">
</app-form-input>

